import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

const InputField = ({ placeholder }) => {
  return (
    <div className="form-item">
      <Field name="keys" component="input" type="text" placeholder={placeholder} className="form-input keys" />
    </div>
  );
};

InputField.propTypes = {
  placeholder: PropTypes.string.isRequired,
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/InputField.jsx